import $ from 'jquery';
import _ from 'lodash';

import widgetFactory from '../widgetFactory';

const widgetName = 'upload';

const widget = widgetFactory(widgetName, {
  options: {
    endpoint: '/img/upload',
    urlOutput: '#urlOutput',
  },

  _create: function () {
    var self = this;

    this._super(widgetName);

    this.uid = 'upload-' + Math.ceil(Math.random() * 1e15);
    this.$fileInput = $('<input type="file" name="Image[file]">')
      .attr({
        accept: 'image/*',
      })
      .appendTo(this.element)
      .on('change', function () {
        self._onSelectFile(this.files[0].size);
      });

    $('*', this.element).wrapAll('<form>');

    this.elements.$form = $('form', this.element).addClass('form').css('position', 'static').attr({
      method: 'post',
      enctype: 'multipart/form-data',
      action: this.options.endpoint,
      target: this.uid,
    });

    $('<input type="hidden">')
      .attr({
        name: 'callback',
        value: 'window.parent["' + this.uid + '"]',
      })
      .appendTo(this.elements.$form);

    this.elements.$iframe = $('#uploadFrame');
    this._createIframe();
  },

  _setLoadingState: function (state) {
    this.elements.$form.toggleClass('loading', state);
  },

  _onSelectFile: function (fileSize) {
    var self = this;

    if (!_.isNil(this.options.fileSizeWarning) && fileSize > this.options.fileSizeWarning) {
      const canUpload = this._trigger('onFileSizeWarning');
      if (!canUpload) {
        this.$fileInput.val('');
        return;
      }
    }

    // create temporary callback
    window[this.uid] = function () {
      self._onFileUploaded.apply(self, arguments);
      delete window[self.uid]; // autodestroy callback
    };

    this._setLoadingState(true);
    this._trigger('startUpload', null);
    this.elements.$form.submit();
  },

  _onFileUploaded: function (success, response) {
    this._setLoadingState(false);

    if (success) {
      $(this.options.urlOutput).val(response);
    }

    this._trigger('uploaded', null, success ? { url: response } : { error: response });
  },

  _createIframe: function () {
    this.elements.$iframe = $('<iframe src="javascript:;"></iframe>')
      .attr({
        id: this.uid,
        name: this.uid,
      })
      .css({
        position: 'absolute',
        left: '-99999px',
        width: 0,
        height: 0,
      })
      .appendTo(this.element);
  },
});

export default widget;
